<div class="modal-header">
    <h3 class="modal-title">Clock In</h3>
</div>
<div class="modal-body">
    <div class="row" style="margin-bottom: 12px;">
        <div class="col-md-12">
            <strong>Job:</strong>
            <ng-select bindLabel="DisplayValue"
                       [searchable]="true"
                       [(ngModel)]="formData.selectedJob"
                       (change)="jobChanged()"
                       [clearable]=false
                       dropdownPosition="bottom">
                <ng-option *ngFor="let job of jobs" [value]="job">{{job.DisplayValue}}</ng-option>
            </ng-select>
        </div>
        <div class="col-md-12" style="margin-top:10px;">
            <strong>Phase:</strong>
            <ng-select bindLabel="PhaseDescription"
                       [searchable]="true"
                       [(ngModel)]="formData.selectedPhase"
                       [clearable]=false
                       dropdownPosition="bottom">
                <ng-option *ngFor="let phase of phases" [value]="phase">
                    <div>{{phase.PhaseDescription}}</div>
                </ng-option>
            </ng-select>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-default"
            (click)="cancelClicked()">
        Cancel
    </button>
    <button type="button" class="btn btn-success" [disabled]="((formData.selectedJob?.JCJMKeyID == null || formData.selectedPhase?.JCJPKeyID == null) && !tcClockIOIgnoreJobPhase) || (tcClockIOIgnoreJobPhase && (formData.selectedJob == null || formData.selectedPhase == null))"
            (click)="clockInClicked()">
        Clock In
    </button>
</div>
